<template>
    <!-- <div> -->
        <div class="wbs-row chatter-bar schedule-bar-wrapper">
            <div v-if="chatter.occupancy >= 0" class="schedule-bar" :class="chatterScheduleBarStyleByStatus[chatter.status]">
                <div class="schedule-label" :class="{'overdue': chatter.isOverdue}" :style="{marginLeft: offset, width: occupancy}">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + chatter.title + ']'}}</span>
                    <span @mouseover="mouseOverHandler" 
                        @mouseleave="mouseLeaveHandler"
                        @mousemove="mouseMoveHandler"
                        @click="showChatDetail(chatter.chatId, $event)"
                        style="width:100%; display: inline-block; height:100%; padding-top: 0.5rem;">{{ chatter.startDate}} ~ {{ chatter.dueDate }} 
                    </span>
                </div>

                <div class="occupancy" :style="getOccupancy()" :class="{'isHovered' : isHovered}" ref="occupancy" 
                    @mouseover="mouseOverHandler"
                    @mouseleave="mouseLeaveHandler"
                    @mousemove="mouseMoveHandler"
                    @click="showChatDetail(chatter.chatId, $event)">
                </div>
            </div>
            
            <div v-else style="width:100%" class="tbd-wrapper">
                <span class="schedule-tbd" @mouseover="mouseOverHandler"
                    @mouseleave="mouseLeaveHandler"
                    @mousemove="mouseMoveHandler"
                    @click="showChatDetail(chatter.chatId, $event)">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + chatter.title + ']'}}</span>
                    <span class="tbd-label">TBD</span>
                </span>
            </div> 
            <div v-if="isHovered" :style="{ top: mouseY + 'px', left: mouseX + 'px' }" class="schedule-tooltip" ref="scheduleTooltip">
                <div class="tooltip-header">
                    <div style="display: flex; align-items: center;">
                        MeMO
                        <span class="status-area">
                            <status-badge :status="chatter.status">{{formatStatusLabel(chatter.status) }}</status-badge>
                            <status-badge v-if="chatter.isOverdue" status="OVERDUE">Overdue</status-badge>
                        </span>
                    </div>
                   
                    <div>
                        <template v-for="num in 3">
                            <span v-if="chatter['l' + num]" :key="num" class="project-level"> {{ chatter['l' + num] }} <span class="separator"> > </span></span>
                        </template>
                        <span class="project-level"> {{ chatter.title }}</span>
                    </div>
                </div>
                
                <div class="tooltip-content">
                    <div>
                        <span class="tooltip-content_label">ID:</span>
                        <span class="tooltip-content_data">{{ this.chatter.chatId}}</span>
                    </div>
                    <div>
                        <span class="tooltip-content_label">Assignee</span>
                        <span class="tooltip-content_data">{{ this.chatter.userName}}</span>
                    </div>
                    <div>
                        <span class="tooltip-content_label">Start Date:</span>
                        <span class="tooltip-content_data">{{ this.chatter.startDate || '-' }}</span>
                    </div>
                    <div>
                        <span class="tooltip-content_label">Due Date:</span>
                        <span class="tooltip-content_data">{{ this.chatter.dueDate || '-' }}</span>
                    </div>
                    <div>
                        <span class="tooltip-content_label">Last Update:</span>
                        <span class="tooltip-content_data">{{ this.chatter.updatedDate }}</span>
                    </div>
                </div>
                    
                
                
            </div> 
            <template v-if="isExpanded">
                <template v-for="subChatter in chatter.subChatterList">
                    <chatter-schedule-bar :chatter="subChatter" :depth="depth + 1" :key="subChatter.chatId"/>
                </template>
            </template>
        </div>
        <!-- <div class="wbs-row schedule-bar-wrapper" :class="{'overdue' : chatter.isOverdue}">
            <div v-if="chatter.occupancy > 0" class="schedule-bar-item occupancy" :class="chatterScheduleBarStyleByStatus[chatter.status]" :style="getChatterScheduleBar">
                <span class="schedule-start">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + chatter.title + ']'}}</span>
                    {{ chatter.startDate }} ~ {{ chatter.dueDate }}
                </span>
            </div>
            <div v-else class="tbd-wrapper">
                <span class="schedule-tbd">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + chatter.title + ']'}}</span>
                    TBD
                </span>
            </div> 
        </div> -->
        <!-- 자신을 재귀적으로 호출 -->

    <!-- </div> -->

</template>
<script>
    
    // import ChatterScheduleBar from './ChatterScheduleBar.vue';
    import StatusBadge from './StatusBadge.vue';
    export default {

        name: "ChatterScheduleBar",
        props: {
            chatter : {type: Object},
            depth: {type: Number, default: 0}
        },
        components: {
            // ChatterScheduleBar
            StatusBadge
        },
        created() {
            this.offset = this.chatter.offset + '%';
            this.occupancy = this.chatter.occupancy + '%';
            this.height = 10 + '%';
        },
        data() {
            return {
                chatterScheduleBarStyleByStatus : {
                    TO_DO : 'schedule-to-do',
                    IN_PROGRESS : 'schedule-in-progress',
                    DONE : 'schedule-done',
                    CANCELLED : 'schedule-cancelled',
                    CLOSED : 'schedule-closed',
                },
                offset: '0%',
                occupancy: '0%',
                height: '0%',
                isHovered: false,
                mouseX: 0,
                mouseY: 0,
                tooltipWidth: 0
            }
        },
        computed : {
            // getChatterScheduleBar() {
            //     const offset = this.chatter.offset + '%';
            //     const occupancy = this.chatter.occupancy + '%';
            //     return {marginLeft: offset, width: occupancy};
            // },
            isExpanded() {
                return this.$store.getters["wbs/getExpanded"](this.chatter.chatId);
            },
            isWbsChartExpanded() {
                return this.$store.getters['wbs/getWbsScheduleChartExpandState'];
            },
            colorInfoByStatusAndDepth() {
                return this.$store.getters['wbs/getColorInfoByStatusAndDepth'];
            },
            viewportWidth() {
                return window.innerWidth;
            }
        },
        methods :{
            getOccupancy() {
                let depth = 0;
                if(this.depth >= 4) {
                    depth = 4;
                } else {
                    depth = this.depth;
                }
                
                return {
                    marginLeft: this.offset,
                    width: this.occupancy,
                    backgroundColor: this.colorInfoByStatusAndDepth[this.chatter.status][depth],
                    // border: '2px solid ' + this.colorInfoByStatusAndDepth[this.chatter.status][this.colorInfoByStatusAndDepth[this.chatter.status].length - 1],
                }
            },
            mouseOverHandler() {
                this.isHovered = true;
               
                this.$nextTick(() => {
                    this.tooltipWidth = this.$refs.scheduleTooltip.offsetWidth;
                })
                
            },

            mouseLeaveHandler() {
                this.isHovered = false;
            },

            mouseMoveHandler(event) {
                const defaultOffset = 30;
                // 마우스 위치와 툴팁 넓이의 합이
                // 클라이언트 뷰포트 - 마우스 위치보다 크다면 
                // 툴팁을 왼쪽으로 이동

                // 마우스 위치 X
                const clientX = event.clientX;
                // 마수으 위치
                const clientY = event.clientY;
                if(clientX + this.tooltipWidth + defaultOffset >= this.viewportWidth) {
                    this.mouseX = clientX - (defaultOffset + this.tooltipWidth)
                } else {
                    this.mouseX = clientX + defaultOffset;
                }
    
                // this.mouseX = event.clientX - (30 + event.clientX ); // 빼는 것을 event.clientX가 아닌 tooltipWidth로 해야함
                this.mouseY = clientY - 5;
            },

            formatStatusLabel(text) {
                if(!text) return;
                const words = text.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
                return words.join(" ");
            },
            showChatDetail(chatId, event) {
                event.stopPropagation();
                this.$router.push({ name: "chatUpdate", params: { id: chatId } });
            },
        }
    }
</script>

<style>
* {
    box-sizing: border-box;
}
/* .chatter-bar.schedule-bar-wrapper .occupancy{
    border-radius: 0;
} */

/* .schedule-bar-wrapper.overdue:hover {
    background-color: #FFC0C0;
} */

.chatter-bar .occupancy {
    cursor: pointer;
}
.chatter-bar .schedule-bar div.schedule-label:hover {
    cursor: pointer;
}

.schedule-to-do .occupancy {
    border: 2px solid #262626;
}


.schedule-in-progress .occupancy {
    border: 2px solid #FF5C00;
}


.schedule-done .occupancy {
    border: 2px solid #1424b8;
}


.schedule-cancelled .occupancy {
    border : 2px solid #c6c6cc;
}


.schedule-closed .occupancy {
    border: 2px solid #54BD54;
}
</style>